<template>
  <a
    v-if="active"
    class="fp-maintenance-banner"
    :href="statusPageUrl"
    target="_blank"
    rel="noopener"
  >
    <i class="fp4 fp4-triangle-exclamation"></i>
    <div class="content">
      <span class="text">{{ $t('maintenance_banner.message') }}</span>
      <span class="link">{{ $t('maintenance_banner.link') }}</span>
    </div>
  </a>
</template>

<script>
import Config from '@/shared/Config'

export default {
  data () {
    return {
      statusPageUrl: ''
    }
  },
  computed: {
    active () {
      return this.$store.getters.MAINTENANCE_ACTIVE
    }
  },
  async created () {
    const config = await Config()
    this.statusPageUrl = config.MAINTENANCE_STATUS_PAGE
  }
}
</script>

<style lang="less" scoped>
@import "~@/shared/styles/_variables.less";

.fp-maintenance-banner {
  display: inline-flex;
  align-items: center;
  padding: 4px 12px;
  background-color: @yellow;
  border-radius: 4px;
  font-size: 12px;
  font-family: @global-font-family;
  color: @black;
  text-decoration: none;
  cursor: pointer;
  max-width: 100%;
  max-height: 53px;
  margin: 0 10px;

  &:hover {
    opacity: 0.85;
  }

  i {
    margin-right: 6px;
    font-size: 14px;
    flex-shrink: 0;
    align-self: center;
  }

  .content {
    display: flex;
    align-items: baseline;
    flex-wrap: wrap;
    justify-content: center;
    gap: 4px;
  }

  .link {
    text-decoration: underline;
    font-weight: 600;
    white-space: nowrap;
    margin-left: 0;
    margin-top: 2px;
  }
}
</style>
